import { useModalBehavior } from "@/hooks/behaviors";
import type { FormInstance } from "antd";
import { useState } from "react";
import type { SourcingRequirementApplicationFormFields } from "../type";

export function useCancelReasonBehavior(
  form: FormInstance<SourcingRequirementApplicationFormFields>,
) {
  const { open: modalOpen, closeModal, openModal } = useModalBehavior();
  const [currentCancelIndex, setCurrentCancelIndex] = useState<number | null>(
    null,
  );

  const [sourcingMaterialId, setTargetSourcingMaterialId] = useState<
    number | null
  >(null);

  const handleCancelSourcingChange = (
    checked: boolean,
    index: number,
    id: number,
  ) => {
    if (checked) {
      setCurrentCancelIndex(index);
      setTargetSourcingMaterialId(id);
      openModal();
    }
  };

  const handleCancelModalConfirm = () => {
    if (currentCancelIndex !== null) {
      closeModal();
      setCurrentCancelIndex(null);
      setTargetSourcingMaterialId(null);
    }
  };

  const handleCancelModalCancel = () => {
    if (currentCancelIndex !== null) {
      // 强制设置 checkbox 为 false
      form.setFieldValue(
        ["materialList", currentCancelIndex, "isSourcingCancel"],
        false,
      );
    }

    closeModal();
    setCurrentCancelIndex(null);
    setTargetSourcingMaterialId(null);
  };

  return {
    cancelReasonModalOpen: modalOpen,
    handleCancelModalCancel,
    handleCancelModalConfirm,
    handleCancelSourcingChange,
    sourcingMaterialId,
  };
}
